module.exports = __webpack_public_path__ + "static/media/1_clickU_46,25_1,3.091b83e4.png";